"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignFees = assignFees;
exports.create = create;
exports["default"] = void 0;
exports.deleteAttachment = deleteAttachment;
exports.deleteContract = deleteContract;
exports.getAccountContracts = getAccountContracts;
exports.getAttachments = getAttachments;
exports.getBatchApplicableContracts = getBatchApplicableContracts;
exports.getContract = getContract;
exports.getProjects = getProjects;
exports.linkContracts = linkContracts;
exports.rolloverCredits = rolloverCredits;
exports.search = search;
exports.typeahead = typeahead;
exports.unlinkContracts = unlinkContracts;
exports.update = update;
exports.updateLinkedContracts = updateLinkedContracts;

var _api = _interopRequireWildcard(require("./api"));

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var base = '/api/contract';

function create(contractFormData) {
  return _api["default"].post(base, contractFormData).then(_api.extractData)["catch"](_api.errorHandler);
}

function update(oldContractData, contractFormData) {
  var contractData = contractFormData;
  return _api["default"].put("".concat(base, "/").concat(oldContractData.id), contractData).then(_api.extractData)["catch"](_api.errorHandler);
}

function getContract(contractId) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _api["default"].get("".concat(base, "/").concat(contractId).concat(opts.light ? "?light=".concat(opts.light) : '')).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteContract(contractId) {
  return _api["default"]["delete"]("".concat(base, "/").concat(contractId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAccountContracts(accountId) {
  return _api["default"].get("".concat(base, "/account/").concat(accountId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function linkContracts(contractId, contractIds, linkReason) {
  return _api["default"].post("".concat(base, "/").concat(contractId, "/linked-contracts"), {
    contractIds: contractIds,
    linkReason: linkReason || undefined
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateLinkedContracts(contractAId, contractBId, linkReason) {
  var url = "".concat(base, "/").concat(contractAId, "/linked-contracts/").concat(contractBId);
  return _api["default"].put(url, {
    linkReason: linkReason
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function unlinkContracts(contractAId, contractBId) {
  var url = "".concat(base, "/").concat(contractAId, "/linked-contracts/").concat(contractBId);
  return _api["default"]["delete"](url).then(_api.extractData)["catch"](_api.errorHandler);
}

function getProjects(contractId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return _api["default"].get("".concat(base, "/").concat(contractId, "/projects?page=").concat(page, "&limit=").concat(limit)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAttachments(contractId) {
  return _api["default"].get("".concat(base, "/").concat(contractId, "/attachments")).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteAttachment(fileId) {
  return _api["default"]["delete"]("".concat(base, "/attachments/").concat(fileId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function rolloverCredits(fromId, toId) {
  return _api["default"].put("".concat(base, "/").concat(fromId, "/rollover-credits/").concat(toId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function typeahead(q, parentAccountId) {
  var queryParams = _queryString["default"].stringify({
    q: q,
    parentAccountId: parentAccountId
  });

  return _api["default"].get("".concat(base, "/typeahead?").concat(queryParams)).then(_api.extractData)["catch"](_api.errorHandler);
}

function assignFees(_ref) {
  var fees = _ref.fees,
      contractId = _ref.contractId;
  return _api["default"].put("".concat(base, "/assign-fees"), {
    fees: fees,
    contractId: contractId
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getBatchApplicableContracts(feeIds) {
  return _api["default"].put("".concat(base, "/bach-applicable-contracts"), {
    feeIds: feeIds
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function search(query) {
  return _api["default"].post('/api/contract/search', query).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  create: create,
  update: update,
  getContract: getContract,
  deleteContract: deleteContract,
  getAccountContracts: getAccountContracts,
  linkContracts: linkContracts,
  updateLinkedContracts: updateLinkedContracts,
  unlinkContracts: unlinkContracts,
  getProjects: getProjects,
  getAttachments: getAttachments,
  deleteAttachment: deleteAttachment,
  rolloverCredits: rolloverCredits,
  typeahead: typeahead,
  assignFees: assignFees,
  getBatchApplicableContracts: getBatchApplicableContracts,
  search: search
};
var _default = api;
exports["default"] = _default;